import { ResourceDWR } from "./ResourceDWR";
import { EResourceFormat } from "./EResourceFormat";
import { AvailabilitySourceService } from "../contexts/EResourceAvailabilityContext";

export interface HostSystemItemView extends HostSystemItem {
  itemId: string | null;
  resource: ResourceDWR | null;
  resourceMapping: string; // host system bibliographic id
}

export interface HostSystemItemViews {
  totalLoans: number;
  totalLoansOverdue: number;
  // Loans Controller handles this differently than other objects I've seen so i've defined 'loans' as the object we can change this
  loans: HostSystemItemView[];
}

export type AvailabilitySourceServiceValue = `${AvailabilitySourceService}`;

// we need a typeguard because HostSystemItemView.eresourceService can be an empty string in a lot of different return cases
export function isAvailabilitySourceServiceValue(
  data: string,
): data is AvailabilitySourceService {
  return Object.values(AvailabilitySourceService).includes(
    data as AvailabilitySourceService,
  );
}

// TODO it's silly we use this generic interface for everything.
// Create narrower types for holds, loans, and loan history objects as well as eResource vs physical differences.
// As is, it's very difficult to understand what properties are actually expected on these objects in each context.
export interface HostSystemItem {
  id: string;
  collection: string | null;
  title: string;
  titleSortKey: string;
  author: string;
  authorSortKey: string;
  chronology: string | null;
  chronologySortKey: string;
  enumeration: string | null;
  enumerationSortKey: string;
  holdPickupDate: string | null;
  holdPickupBranch: string | null;
  holdQueueLength: string;
  holdQueueLengthAsLong: number | null;
  holdPickupBy: Date | null;
  bibliographicId: string;
  dueDate: number | null; // Date, serialized as ms not ISO string
  outDate: number | null; // Date
  returnedDate: number | null; //Date
  message: string | null;
  fee: number | null;
  holdNumber: string;
  holdRequestedDate: Date | null;
  holdCancelable: boolean;
  loanCancelable: boolean;
  status: string | null;
  suspendUntilDate: Date | null;
  holdPickupBranchId: number | null;
  chargeNumber: string | null;
  downloadable: boolean;
  pushable: boolean;
  holdSuspendable: boolean;
  eresourceUrl: string | null;
  useRedirectForURL: boolean;
  eresourceId: string | null;
  formatInfo: EResourceFormat[];
  renewable: boolean;
  renewalCount: number;
  renewalLimit: number | null;
  sortStatus: string; // Derived from the `getSortStatus()` method
  holdPickupByString: string; // Derived from the `getHoldPickupByString()` method
  dueDateString: string; // Derived from the `getDueDateString()` method
  outDateString: string; // Derived from the `getOutDateString()` method
  returnedDateString: string; // Derived from the `getReturnedDateString()` method
  holdRequestedDateString: string; // Derived from the `getHoldRequestedDateString()` method
  suspendUntilDateString: string; // Derived from the `getSuspendUntilDateString()` method
  feeComment: string; // Derived from the `getFeeComment()` method
  eresourceService:
    | AvailabilitySourceServiceValue
    | AvailabilitySourceService
    | ""; // Derived from the `getEResourceService()` method
}
